import { useContext } from 'react';
import { ScrapeContext } from '../contexts/ScrapeContext';

export const useScrape = () => {
    const context = useContext(ScrapeContext);
    if (!context) {
        throw new Error('useScrape must be used within ScrapeProvider');
    }
    return context;
};